module.exports = __webpack_public_path__ + "img/ico-share.59d578c5.svg";